import styles from './space-members.module.scss';
import { FC } from 'react';
import { TSpace } from 'models/common';
import { WTooltip, WTypography } from 'components/wrappers/wrapper';
import ProfilePhoto from '../profile-photo/profile-photo';

interface SpaceMembersProps {
  className?: string;
  totalCount: number;
  data: TSpace[];
  onClick?: () => void;
}
const SpaceMembers: FC<SpaceMembersProps> = ({ className, totalCount, data, onClick }) => {
  const getSpaceDataCount = () => {
    const count = (totalCount || 0) - 3;
    if (count > 0) return `+${count}`;
    return '';
  };

  const classes = `${styles.spaceMembers} ${className || ''}`.trim();
  if (!data?.length) return null;
  return (
    <div className={classes}>
      <WTooltip title="See all members" placement="bottom">
        <div className={styles.stats} onClick={onClick}>
          <div
            className={styles.circles}
            style={{ minWidth: `calc(${data.length * 1.75}rem - 0.375rem)` }}
          >
            {data?.map((item, i) => (
              <div style={{ right: i * 24 }} key={item._id}>
                <ProfilePhoto
                  radius="100%"
                  user={item.user}
                  width="1.75rem"
                  height="1.75rem"
                  fontSize="0.75rem"
                />
              </div>
            ))}
          </div>
          <WTypography className={styles.text}>{getSpaceDataCount()}</WTypography>
        </div>
      </WTooltip>
    </div>
  );
};

export default SpaceMembers;
